module.exports = __webpack_public_path__ + "static/mediumIntro-cfa51e7f53d7deffdd409fe4770fbe86.mp4";